
        import 'FormattedPrice.2afe125.css-module'
        export default {"FormattedPrice":"FormattedPrice_FormattedPrice_2afe125","pending":"pending_FormattedPrice_2afe125","beforeDiscount":"beforeDiscount_FormattedPrice_2afe125"}
    